import { Injectable } from '@angular/core';

@Injectable()
export class CountryCodesService {

  constructor() { }

  getCountryCodes() {
    let map = new Map<string, string>();
    map.set('Ghana', '233');
    map.set('Liberia', '231');
    map.set('Guinea Bissau', '245');
    map.set('Guinea', '224');
    map.set('Benin', '229');
    map.set('CIV', '225');
    map.set('Nigeria', '234');
    map.set('Congo-B', '242');
    map.set('Cameroon', '237');
    return map;
  }

}
